import { type CommonModalProps } from 'renderer/components/CommonModal/context';
import CookieConsent from 'renderer/components/CookieConsent';
import cookieConsentStyles from 'renderer/components/CookieConsent/CookieConsent.module.scss';

interface CookieConsentModalProps {
  viewCookiePreferences?: boolean;
}

export const CookieConsentModalData = ({
  viewCookiePreferences,
}: CookieConsentModalProps): CommonModalProps => {
  return {
    id: 'cookieConsentModal',
    titleText: 'Our Cookies',
    contentClassName: cookieConsentStyles.cookieConsentModalWrapper,
    className: cookieConsentStyles.cookieConsentModal,
    cannotClose: true,
    children: <CookieConsent viewCookiePreferences={viewCookiePreferences} />,
  };
};
